// extracted by mini-css-extract-plugin
export default {"container":"AccordionPage_container__bEQx-"};